import React from 'react'
import { Alert, Grid, Box } from '@mui/material'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'
import { faTimesCircle } from '@fortawesome/pro-duotone-svg-icons/faTimesCircle'
import { faChevronLeft } from '@fortawesome/pro-duotone-svg-icons/faChevronLeft'

import LoadingDefault from '@/Components/Elements/Loading/LoadingDefault'
import DefaultGrid from '@/feature/Grid/DefaultGrid'
import LoadingPage from '@/Components/Elements/Loading/LoadingPage'
import { toast } from 'react-toastify'
import ShowMultiAdd from './ShowMultiAdd'
import Sidebar from '@/Components/Elements/Sidebar/Sidebar'
import DetailContentDossier from '../../Detail/ContentDossier'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import {
    NewContentDossierProps,
    NewContentDossierState,
    DisplayItem,
    DefaultGridRef,
    Condition,
} from './types'

class NewContentDossier extends React.Component<
    NewContentDossierProps,
    NewContentDossierState
> {
    dpMain = React.createRef<DefaultGridRef>()

    constructor(props: NewContentDossierProps) {
        super(props)
        this.state = {
            changed: {},
            embedded: false,
            showExisting: false,
            ignoreWarning: false,
            content: this.props.content ? this.props.content : {},
            edit: true,
            errors: {},
            denied_error: false,
            id: this.props.defDossierId
                ? this.props.defDossierId
                : this.props.match?.params.id,
            items: [],
            loading: false,
            redirect: false,
            toastOptions: {
                position: 'bottom-center',
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            },
            showModal: false,
            existingUser: null,
            showMultiAddModal: false,
        }

        this.onChangeValue = this.onChangeValue.bind(this)
        this.getAllValues = this.getAllValues.bind(this)
        this.isValid = this.isValid.bind(this)
        this.submitDossier = this.submitDossier.bind(this)
        this.renderExistingDossier = this.renderExistingDossier.bind(this)
    }

    fetchDisplayItems(): void {
        const kedo = this.props.kedo
        const params = {
            params: {
                view: ['edit', 'show/edit'],
                defDossier: this.state.id,
                displayPosition: ['main_content'],
                sort: ['rank', 'col'],
                sortOrder: ['ASC', 'ASC'],
            },
        }

        this.setState({ loading: true })
        kedo.api()
            .getCached(kedo.api().getDefDossierEndpoint() + '/' + this.state.id)
            .then((ddResponse: any) => {
                kedo.api()
                    .getCached(kedo.api().getDisplayItemEndpoint(), params)
                    .then((response: any) => {
                        this.setState({
                            defDossier: ddResponse.data,
                            loading: false,
                            items: response.data.results,
                            pager: response.data.pager,
                        })
                    })
            })
    }

    findAddress() {
        const { defDossier } = this.state
        if (!defDossier?.settings?.address_lookup_settings) return

        const addressSettings = defDossier.settings.address_lookup_settings
        const kedo = this.props.kedo
        const values = this.dpMain.current?.getValues() ?? {}

        const streetDdiId = parseInt(addressSettings.street_ddi)
        const zipcodeDdiId = parseInt(addressSettings.zipcode_ddi)
        const housenrDdiId = parseInt(addressSettings.housenr_ddi)
        const housenrSufDdiId = parseInt(addressSettings.housenrsuf_ddi)
        const municipalityDdiId = parseInt(addressSettings.municipality_ddi)
        const longDdiId = parseInt(addressSettings.long_ddi)
        const latDdiId = parseInt(addressSettings.lat_ddi)

        //Don't do a lookup if the address is already known.
        if (values[streetDdiId] && values[streetDdiId].length > 0) {
            //return;
        }

        //Need more values to be able to
        if (
            (!values[zipcodeDdiId] || values[zipcodeDdiId].length <= 0) &&
            (!values[housenrDdiId] || values[housenrDdiId].length <= 0)
        ) {
            return
        }

        const params = {
            apikey: '843e29ec811a047e6aa877e521248a43',
            postcode: values[zipcodeDdiId],
            housenumber: values[housenrDdiId],
            suffix: values[housenrSufDdiId],
            districts: false,
            neighbourhoods: false,
        }

        kedo.api()
            .getFull(
                'https://bag.kedo.nu/byPostCode',
                {
                    disableSecurity: true,
                    params: params,
                },
                false
            )
            .then((lookupResult: any) => {
                if (!this.dpMain.current) return

                if (
                    lookupResult.data.street &&
                    this.dpMain.current['ddiRef' + addressSettings.street_ddi]
                ) {
                    this.dpMain.current[
                        'ddiRef' + addressSettings.street_ddi
                    ].current.ddiRef.current.setVal(
                        'value',
                        lookupResult.data.street
                    )
                }
                if (
                    lookupResult.data.city &&
                    this.dpMain.current['ddiRef' + addressSettings.city_ddi]
                ) {
                    this.dpMain.current[
                        'ddiRef' + addressSettings.city_ddi
                    ].current.ddiRef.current.setVal(
                        'value',
                        lookupResult.data.city
                    )
                }
                if (
                    latDdiId &&
                    lookupResult.data.latitude &&
                    this.dpMain.current['ddiRef' + latDdiId]
                ) {
                    this.dpMain.current[
                        'ddiRef' + latDdiId
                    ].current.ddiRef.current.setVal(
                        'value',
                        lookupResult.data.latitude
                    )
                    this.dpMain.current[
                        'ddiRef' + latDdiId
                    ].current.ddiRef.current.setVal(
                        'latitude',
                        lookupResult.data.latitude
                    )
                }
                if (
                    longDdiId &&
                    lookupResult.data.longitude &&
                    this.dpMain.current['ddiRef' + longDdiId]
                ) {
                    this.dpMain.current[
                        'ddiRef' + longDdiId
                    ].current.ddiRef.current.setVal(
                        'value',
                        lookupResult.data.longitude
                    )
                    this.dpMain.current[
                        'ddiRef' + longDdiId
                    ].current.ddiRef.current.setVal(
                        'longitude',
                        lookupResult.data.longitude
                    )
                }
                if (
                    municipalityDdiId &&
                    lookupResult.data.council_name &&
                    this.dpMain.current['ddiRef' + municipalityDdiId]
                ) {
                    this.dpMain.current[
                        'ddiRef' + municipalityDdiId
                    ].current.ddiRef.current.setVal(
                        'value',
                        lookupResult.data.council_name
                    )
                }
            })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(() => {})
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .then(() => {})
    }

    onChangeValue(itemId: number) {
        //BAG: Lookup addresses
        if (
            this.state.defDossier &&
            this.state.defDossier.settings &&
            this.state.defDossier.settings.address_lookup_settings &&
            this.state.defDossier.settings.address_lookup_settings
                .address_lookup === true
        ) {
            if (
                parseInt(
                    this.state.defDossier.settings.address_lookup_settings
                        .zipcode_ddi
                ) === itemId
            ) {
                this.findAddress()
            } else if (
                parseInt(
                    this.state.defDossier.settings.address_lookup_settings
                        .housenr_ddi
                ) === itemId
            ) {
                this.findAddress()
            }
        }

        //TODO KeDo: Check conditions here.
        //TODO KeDo: Check other modules here and maybe change data based on
    }

    getAllValues() {
        const values = this.dpMain.current?.getValues() ?? {}

        if (this.props.embedded && this.props.embedded !== true) {
            values['embedded'] = this.props.embedded
            values['linkId'] = this.props.linkId
        }

        if (this.state.ignoreWarning === true) {
            values['ignore_existing'] = true
        }

        values.defDossier = this.state.id

        return values
    }

    isValid(values: Record<string, any>) {
        const mandatory: Record<string, string> = {}
        this.state.items
            .filter((item) => item.view === 'edit' || item.view === 'show/edit')
            .forEach((item) => {
                if (
                    this.isObligatory(item, values) &&
                    (!values[item.id] || values[item.id].length <= 0)
                ) {
                    mandatory[item.id] = 'This is a required field'
                }
            })

        if (Object.keys(mandatory).length > 0) {
            this.setState({
                errors: mandatory,
                submitting: false,
            })

            const errorId = this.checkErrors(mandatory)
            this.dpMain.current?.doFocus(errorId)

            return false
        }

        return true
    }

    submitDossier(addContinue?: boolean) {
        const kedo = this.props.kedo
        this.setState({ submitting: true })

        const values = this.getAllValues()

        if (!this.isValid(values)) {
            return
        }

        kedo.api()
            .post(kedo.api().getContentDossierEndpoint(), values)
            .then((response: any) => {
                if (addContinue) {
                    this.setState({
                        edit: false,
                        submitting: false,
                        errors: {},
                        content: {},
                        changed: {},
                        saved: true,
                    })
                    setTimeout(() => this.setState({ saved: false }), 5000)
                    setTimeout(() => this.fetchDisplayItems(), 500)
                    setTimeout(
                        () => this.props.onContinueSuccess?.(response.data.id),
                        500
                    )
                } else {
                    this.setState({
                        redirect:
                            this.props.location === 'Block'
                                ? false
                                : response.data.id,
                        edit: false,
                        submitting: false,
                        errors: {},
                    })
                }

                toast.success(
                    this.props.kedo.t('dossier_errors.success_create', {
                        defdossier: kedo
                            .env()
                            .translateItem(this.state.defDossier, 'defdossier'),
                    }),
                    this.state.toastOptions
                )

                if (
                    this.props.location === 'Block' ||
                    (this.props.location === 'EmbeddedLinkField' &&
                        !addContinue)
                ) {
                    this.props.onSuccess?.(response.data.id)
                }
            })
            .catch((error: any) => {
                if (error.response && error.response.status === 409) {
                    this.setState({
                        errors: error?.response?.data?.errors || {},
                        submitting: false,
                    })
                    if (
                        error.response.data.existing &&
                        error.response.data.existing.length > 0
                    ) {
                        this.setState({
                            showExisting: error.response.data.existing,
                            existingConstraintType:
                                error.response.data.constraint_type,
                        })
                    }
                } else if (error.response && error.response.status === 403) {
                    this.setState({
                        denied_error: this.props.kedo.t(
                            'not_allowed_to_create_dossier'
                        ),
                        submitting: false,
                    })

                    toast.error(
                        this.props.kedo.t('dossier_errors.permission_create'),
                        this.state.toastOptions
                    )
                    window.scrollTo(0, 0)
                } else {
                    toast.error(
                        this.props.kedo.t('dossier_errors.error_create'),
                        this.state.toastOptions
                    )
                    this.setState({
                        errors: error?.response?.data?.errors || {},
                        submitting: false,
                    })

                    const errorId = this.checkErrors()
                    this.dpMain.current?.doFocus(errorId)
                }
            })
    }

    preSubmitDossier() {
        if (this.props.multiAdd) {
            this.setState({
                showMultiAddModal: this.isValid(this.getAllValues()),
            })
            return
        }

        this.submitDossier(false)
    }

    renderButtons() {
        const addContinue =
            this.state.defDossier &&
            this.state.defDossier.settings &&
            this.state.defDossier.settings.add_continue === true
                ? true
                : false
        return (
            <Box sx={{ float: 'right', ml: 'auto' }}>
                <StyledButton
                    disabled={this.state.submitting}
                    type="submit"
                    onClick={() => this.preSubmitDossier()}
                    title={this.props.kedo.t('Create')}
                    color="primary"
                >
                    {this.state.submitting ? (
                        <LoadingDefault size={'sm'} as={'span'} />
                    ) : (
                        <FontAwesomeIcon icon={faSave} />
                    )}
                    &nbsp; {this.props.kedo.t('Add')}
                </StyledButton>{' '}
                {addContinue ? (
                    <StyledButton
                        disabled={this.state.submitting}
                        type="submit"
                        onClick={() => this.submitDossier(true)}
                        title={this.props.kedo.t('Create')}
                        color="primary"
                    >
                        {this.state.submitting ? (
                            <LoadingDefault size={'sm'} as={'span'} />
                        ) : (
                            <FontAwesomeIcon icon={faSave} />
                        )}
                        &nbsp; {this.props.kedo.t('Add and continue')}
                    </StyledButton>
                ) : null}
                {this.props.location === 'Block' ||
                this.props.location === 'EmbeddedLinkField' ? (
                    <StyledButton
                        color="secondary"
                        title={this.props.kedo.t('Cancel')}
                        onClick={() => this.props.onClose()}
                    >
                        <FontAwesomeIcon icon={faTimesCircle} />
                        &nbsp; {this.props.kedo.t('Cancel')}
                    </StyledButton>
                ) : (
                    <StyledButton
                        color="secondary"
                        title={this.props.kedo.t('Cancel')}
                        onClick={() => this.props.history.goBack()}
                    >
                        <FontAwesomeIcon icon={faTimesCircle} />
                        &nbsp; {this.props.kedo.t('Cancel')}
                    </StyledButton>
                )}
            </Box>
        )
    }

    isObligatory(item: DisplayItem, values: any) {
        if (
            item.def_dossier_def_field &&
            item.def_dossier_def_field.obligatory &&
            item.def_dossier_def_field.obligatory === true
        ) {
            return true
        }

        if (
            item.def_dossier_link &&
            item.def_dossier_link.obligatory === true
        ) {
            return true
        }

        if (
            this.state.defDossier &&
            this.state.defDossier.settings &&
            this.state.defDossier.settings.conditions
        ) {
            let condResult = false
            this.state.defDossier.settings.conditions.forEach(
                (condition: Condition) => {
                    if (
                        this.dpMain.current?.conditionMatches(condition, values)
                    ) {
                        if (
                            condition.actions
                                .filter(
                                    (action) =>
                                        action.action === 'require_fields'
                                )
                                .filter((action) =>
                                    action.values.find(
                                        (actVal) => actVal === item.id
                                    )
                                ).length > 0
                        ) {
                            condResult = true
                        }
                    }
                }
            )

            return condResult
        }

        return false
    }

    renderSuccessAlert() {
        return (
            <Alert key={'success'} severity={'success'}>
                {this.props.kedo.t('Dossier has been saved successfully')}
            </Alert>
        )
    }

    checkErrors(errors?: Record<string, string>) {
        const values = this.state.items.map((item) => ({
            id: item.id,
            error: errors ? errors[item.id] : this.state.errors[item.id],
        }))

        const focusItem = values.find((item) => item.error)

        return focusItem?.id
    }

    shouldComponentUpdate(
        nextProps: Readonly<NewContentDossierProps>,
        nextState: Readonly<NewContentDossierState>
    ): boolean {
        if (this.state.items.length !== nextState.items.length) {
            return true
        }

        if (this.state.submitting !== nextState.submitting) {
            return true
        }

        if (
            Object.keys(this.state.errors).length !==
            Object.keys(nextState.errors).length
        ) {
            return true
        }

        return false
    }

    componentDidMount() {
        this.fetchDisplayItems()
    }

    renderExistingDossier() {
        const kedo = this.props.kedo
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                title={this.state.existingUser.summary}
                onClose={() => {
                    this.setState({ showModal: false })
                }}
                headerClose={() => {
                    this.setState({ showModal: false })
                }}
                contentProps={{ dividers: true }}
                actions={
                    <>
                        {this.state.existingConstraintType === 'warning' ? (
                            <StyledButton
                                onClick={() => {
                                    this.setState({ ignoreWarning: true })
                                    setTimeout(
                                        () =>
                                            this.props.onSuccess?.(
                                                this.state.existingUser.id
                                            ),
                                        50
                                    )
                                }}
                            >
                                {kedo.t('Use this')}
                            </StyledButton>
                        ) : null}
                        <StyledButton
                            onClick={() => this.setState({ showModal: false })}
                            color={'secondary'}
                        >
                            {kedo.t('Close')}
                        </StyledButton>
                    </>
                }
            >
                <DetailContentDossier
                    props={{
                        existingUser: true,
                        modalized: true,
                        dossierId: this.state.existingUser.id,
                        disableBreadcrumb: true,
                    }}
                    kedo={this.props.kedo}
                />
            </AppDialog>
        )
    }

    renderExisting() {
        const kedo = this.props.kedo

        if (this.state.showModal !== false) {
            return this.renderExistingDossier()
        }

        return (
            <>
                <AppDialog
                    aria-labelledby="contained-modal-title-vcenter"
                    open
                    maxWidth={'lg'}
                    fullWidth
                    title={kedo.t('Already existing items')}
                    onClose={() => this.setState({ showExisting: false })}
                    headerClose={() => this.setState({ showExisting: false })}
                    contentProps={{ dividers: true }}
                    actions={
                        <>
                            {this.state.existingConstraintType === 'warning' ? (
                                <StyledButton
                                    onClick={() => {
                                        this.setState({ ignoreWarning: true })
                                        setTimeout(
                                            () => this.submitDossier(),
                                            50
                                        )
                                    }}
                                >
                                    {kedo.t('Ignore warning and save')}
                                </StyledButton>
                            ) : null}
                            <StyledButton
                                onClick={() =>
                                    this.setState({ showExisting: false })
                                }
                                color={'secondary'}
                            >
                                {kedo.t('Close')}
                            </StyledButton>
                        </>
                    }
                >
                    <div>
                        <p>{kedo.t('existing_items_description')}</p>
                        <ul className={'list-group'}>
                            {Array.isArray(this.state.showExisting) &&
                                this.state.showExisting.map((existingItem) => (
                                    <li
                                        key={existingItem.id}
                                        className={
                                            'list-group-item list-group-item-action'
                                        }
                                        onClick={() => {
                                            this.setState({
                                                showModal: true,
                                                existingUser: existingItem,
                                            })
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {existingItem.summary
                                            ? existingItem.summary
                                            : existingItem.id}
                                    </li>
                                ))}
                        </ul>
                    </div>
                </AppDialog>
            </>
        )
    }

    renderMultiAdd() {
        //TODO: Add check
        return (
            <ShowMultiAdd
                kedo={this.props.kedo}
                displayItems={this.state.items}
                handleGetValues={this.getAllValues}
                handleSuccess={() => {
                    if (this.props.onSuccess && this.state.redirect) {
                        this.props.onSuccess(this.state.redirect)
                    }
                }}
                handleClose={() => this.setState({ showMultiAddModal: false })}
                dossierData={this.dpMain.current?.getValues() ?? {}}
                defDossier={this.state.defDossier}
            />
        )
    }

    render() {
        const kedo = this.props.kedo
        if (this.state.redirect !== false) {
            if (this.props.embedded) {
                // this.props.onSuccess(this.state.redirect);
                return ''
            }
            return <Redirect to={`/contentdossier/${this.state.redirect}`} />
        }

        if (
            !this.state.defDossier ||
            this.state.loading ||
            (this.props.match && this.state.id !== this.props.match.params.id)
        ) {
            return <LoadingPage />
        }

        return (
            <Grid container>
                {this.props.leftSideBar && window.innerWidth > 576 ? (
                    <Grid
                        sx={{ borderRight: '1px solid #dee2e6' }}
                        size={{ xs: 4 }}
                    >
                        <Sidebar
                            kedo={kedo}
                            defDossier={this.state.defDossier}
                            embeddedDefDossierId={
                                this.props.embeddedDefDossierId
                            }
                            dossierId={this.props.embedded}
                            leftSideBar={this.props.leftSideBar}
                        />
                    </Grid>
                ) : null}
                <Grid
                    size={
                        this.props.leftSideBar && window.innerWidth > 576
                            ? 8
                            : 12
                    }
                >
                    {this.state.showMultiAddModal
                        ? this.renderMultiAdd()
                        : null}
                    {this.state.showExisting !== false
                        ? this.renderExisting()
                        : null}
                    {this.state.denied_error !== false ? (
                        <Alert severity={'warning'}>
                            {this.state.denied_error}
                        </Alert>
                    ) : null}
                    {this.state.saved === true ? (
                        <Alert severity={'success'}>
                            {kedo.t('Dossier has been saved successfully')}
                        </Alert>
                    ) : null}
                    <div
                        className={
                            this.props.location === 'EmbeddedLinkField'
                                ? ''
                                : 'mainContainer'
                        }
                    >
                        {this.state.showSaveSuccess === true
                            ? this.renderSuccessAlert()
                            : null}
                        {this.props.location === 'EmbeddedLinkField' ? null : (
                            <Grid container>
                                <Grid size={8}>
                                    <h1>
                                        {this.props.multiAdd ? (
                                            <small>{kedo.t('Multi add')}</small>
                                        ) : null}
                                        {kedo.t('New')}{' '}
                                        {kedo
                                            .env()
                                            .translateItem(
                                                this.state.defDossier,
                                                'defdossier'
                                            )}
                                    </h1>
                                </Grid>
                                {this.state.items.length ? (
                                    <Grid size={4}>{this.renderButtons()}</Grid>
                                ) : null}
                            </Grid>
                        )}
                        <div>
                            {this.props.multiAdd ? (
                                <Alert severity={'info'}>
                                    {kedo.t('multi_add_dossier_header')}
                                </Alert>
                            ) : null}
                            <DefaultGrid
                                changeValue={this.onChangeValue}
                                conditions={
                                    this.state.defDossier &&
                                    this.state.defDossier.settings &&
                                    this.state.defDossier.settings.conditions
                                        ? this.state.defDossier.settings
                                              .conditions
                                        : []
                                }
                                content={this.state.content}
                                embedded={this.props.embedded}
                                linkId={this.props.linkId}
                                errors={this.state.errors}
                                hiddenfields={
                                    this.state.defDossier &&
                                    this.state.defDossier.settings &&
                                    this.state.defDossier.settings.hiddenfields
                                        ? this.state.defDossier.settings
                                              .hiddenfields
                                        : []
                                }
                                items={this.state.items}
                                kedo={this.props.kedo}
                                mode={'edit'}
                                ref={this.dpMain}
                            />
                            <Grid container>
                                <Grid size={12}>{this.renderButtons()}</Grid>
                            </Grid>
                        </div>
                    </div>
                </Grid>
                {this.props.defDossierId ? null : (
                    <Grid size={12}>
                        <StyledButton
                            className={'goBackButton'}
                            color={'secondary'}
                            onClick={() => this.props.history.goBack()}
                        >
                            <FontAwesomeIcon icon={faChevronLeft} />
                            &nbsp; {this.props.kedo.t('Back to overview')}
                        </StyledButton>
                    </Grid>
                )}
            </Grid>
        )
    }
}

export default NewContentDossier
